// extracted by extract-css-chunks-webpack-plugin
module.exports = {"description":"description","stats":"stats"};